import { atom, onMount, task } from "nanostores";
import { requestGet } from "../utils/request.ts";
import { $username } from "./user_info.ts";

export interface CameraInfo {
    camera_id: number;
    camera_name: string;
    group_name?: string;
    camera_pinned_time: number;
    photo_count: number;
    status: Record<string, string>;
    last_photo_time: number;
    last_photo_id: number;
    capture_interval?: string;
    subscription_expire?: number;
    oss_type?: "paid" | "own" | "none";
    [key: string]: any; // Allow index access for DataGrid
}

const CAMERA_INFO_FIELDS = [
    "camera_name",
    "group_name",
    "camera_pinned_time",
    "photo_count",
    "status",
    "last_photo_time",
    "last_photo_id",
    "capture_interval",
    "subscription_expire",
    "oss_type",
];

export const $cameraList = atom([] as CameraInfo[]);
export const $cameraListLoaded = atom(false);

export const updateCameraInfo = async () => {
    // fetch list
    const resp = await requestGet<{ cameras: CameraInfo[] }>("/v2/camera", {
        fields: CAMERA_INFO_FIELDS.join(","),
    });
    $cameraList.set(resp.cameras);
    $cameraListLoaded.set(true);
};

export const getCameraInfoById = (cameraId: number) => {
    for (const info of $cameraList.get()) {
        if (info.camera_id === cameraId) return info;
    }
    return undefined;
};

$username.subscribe((val, _oldVal) => {
    if (val === "") {
        $cameraList.set([]);
        $cameraListLoaded.set(false);
        return;
    } else {
        // update camera info
        task(async () => {
            await updateCameraInfo();
        });
    }
});
